module.exports = __webpack_public_path__ + "img/graph_title_pc.5e48ec2.svg";